export const SECONDARY_SECTION_OPTIONS = [
	{
		id: "tutoriales",
		name: { default: "Tutoriales", translationPath: "aprende.tipo_recurso.tutoriales" },
	},
];
